import { QueryKey, useQueryClient } from '@tanstack/react-query'
import { useCallback } from 'react'

/**
 * Custom hook for invalidating a cached query.
 * Marks query as stale, preserves cached data until after refetch.
 * @example
 * const invalidateQuery = useInvalidateQuery()
 * const handleSomeEvent = async () => {
 *   await invalidateQuery(['someQueryKey'])
 * }
 * @returns invalidateQuery
 */
export const useInvalidateQuery = () => {
  const queryClient = useQueryClient()

  const invalidateQuery = useCallback(
    async (queryKey: QueryKey) => {
      await queryClient.invalidateQueries({ queryKey })
    },
    [queryClient],
  )

  return invalidateQuery
}
